import { Search, X } from 'lucide-react';
import { fieldCls } from './styles';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** Accessible label (defaults to "Search"). */
  label?: string;
  /** Sizing/flex utilities for the wrapper (e.g. "flex-1 basis-56"). */
  className?: string;
  /** Focus passthrough (dropdown pickers open their results on focus). */
  onFocus?: () => void;
  autoFocus?: boolean;
}

/**
 * Search field with a leading icon and a clear-X button (shown when non-empty).
 * Standardizes every search box platform-wide — same icon, same clearable
 * behavior, same 44px mobile touch target.
 */
export default function SearchInput({ value, onChange, placeholder = 'Search…', label = 'Search', className = '', onFocus, autoFocus }: Props) {
  return (
    <div className={`relative min-w-0 ${className}`}>
      <Search className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400" />
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={onFocus}
        autoFocus={autoFocus}
        placeholder={placeholder}
        aria-label={label}
        className={`${fieldCls} min-h-[44px] w-full pl-8 sm:min-h-0 ${value ? 'pr-9' : ''}`}
      />
      {value && (
        <button
          type="button"
          onClick={() => onChange('')}
          aria-label="Clear search"
          className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-gray-400 transition-colors duration-150 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:hover:text-gray-200"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
}
